import { Engine } from 'engine/Engine';
import { Facet } from 'engine/facets/Facet';

interface ActivatableProps {
  activate: (active: boolean, engine: Engine) => void,
}

export class Activatable extends Facet<ActivatableProps> {
  active = false;
  disabled = false;
  activate(active: boolean, engine: Engine) {
    if (this.active === active) return;
    this.active = active;
    this.props.activate(active, engine);
  }
  disable(disabled: boolean) {
    this.disabled = disabled;
  }
}
